import type { RouteParamsRaw, NavigationFailure } from 'vue-router'
import { ref, nextTick } from 'vue'

// Export a reactive reference that can hold the navigation function
export const tourNavigator = ref<((routeName: string, params?: RouteParamsRaw) => Promise<void | NavigationFailure | undefined>) | null>(null)

// Export a reactive reference that can hold the route checking function
export const routeChecker = ref<((routeName: string) => boolean) | null>(null)

// Helper to set the navigator function
export function setTourNavigator(navigatorFn: (routeName: string, params?: RouteParamsRaw) => Promise<void | NavigationFailure | undefined>) {
  tourNavigator.value = navigatorFn
}

// Helper to set the route checker function
export function setRouteChecker(checkerFn: (routeName: string) => boolean) {
  routeChecker.value = checkerFn
}

// Helper to access the navigator function
export async function navigateTo(routeName: string, params?: RouteParamsRaw): Promise<void | NavigationFailure | undefined> {
  if (tourNavigator.value) {
    const result = await tourNavigator.value(routeName, params)
    await nextTick()
    return result
  }
  console.warn('Tour navigator not available for navigation in tour step')
  return Promise.reject('Tour navigator not available')
}

// Helper to check if current route matches the specified route name
export function isCurrentRoute(routeName: string): boolean {
  if (routeChecker.value) {
    return routeChecker.value(routeName)
  }
  console.warn('Route checker not available for checking route in tour step')
  return false
}
